import { render } from "./DataOverview.vue?vue&type=template&id=4b0bb306"
import script from "./DataOverview.vue?vue&type=script&lang=js"
export * from "./DataOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__